import React from 'react';

const baseClass = `w-full border border-gray-300 rounded-lg text-sm text-gray-900
  bg-white px-3 py-2 transition-colors
  focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500
  disabled:bg-gray-50 disabled:text-gray-400 disabled:cursor-not-allowed
  placeholder:text-gray-400`;

export function Input({ className = '', ...props }) {
  return (
    <input className={`${baseClass} ${className}`} {...props} />
  );
}

export function Select({ children, className = '', ...props }) {
  return (
    <select className={`${baseClass} ${className}`} {...props}>
      {children}
    </select>
  );
}

export function Textarea({ className = '', ...props }) {
  return (
    <textarea className={`${baseClass} ${className}`} rows={3} {...props} />
  );
}

export function Label({ children, required = false, className = '' }) {
  return (
    <label className={`block text-sm font-medium text-gray-700 mb-1 ${className}`}>
      {children}
      {required && <span className="text-red-500 ml-1">*</span>}
    </label>
  );
}

export function FormGroup({ children, className = '' }) {
  return (
    <div className={`flex flex-col gap-1 ${className}`}>
      {children}
    </div>
  );
}
